import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { axiosApi } from '../../_helper/api_helper';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import WarningIcon from '@mui/icons-material/Warning';
import { Link, useNavigate } from 'react-router-dom';

const HireJobModel = (props) => {
  const navigate = useNavigate()
  const { filterData, mutliJobId } = props;
  const client_id = localStorage.getItem("client_Id");
  const [showNoCreditsModal, setShowNoCreditsModal] = useState(false);
  const [clientData, setClientData] = useState({})

  const [hireTalentData, setHireTalentData] = useState({});

  useEffect(() => {
    if (props?.selectedRecruiterId) {
      singleHireApi()

    }
  }, [props?.selectedRecruiterId])
useEffect(()=>{
  if(client_id){
    clitentData()
  }

},[client_id])
  const clitentData = async () => {
    const response = await axiosApi.get(`/clientdata/${client_id}`);
    setClientData(response?.data?.client);
    // handleGetFirstTimeData(response?.data?.client);
  };
  const singleHireApi = async () => {
    const response = await axiosApi.get(`/job/${props?.mutliJobId}/${props?.selectedRecruiterId}`);
    setHireTalentData(response?.data)
  }
  const calculateTimeElapsed = (createdAt) => {
    const currentDate = new Date();
    const postedDate = new Date(createdAt);
    const timeDifference = currentDate - postedDate;

    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (years > 0) {
      return `${years} ${years === 1 ? 'year' : 'years'} ago`;
    } else if (months > 0) {
      return `${months} ${months === 1 ? 'month' : 'months'} ago`;
    } else if (weeks > 0) {
      return `${weeks} ${weeks === 1 ? 'week' : 'weeks'} ago`;
    } else if (days > 0) {
      return `${days} ${days === 1 ? 'day' : 'days'} ago`;
    } else if (hours > 0) {
      return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
    } else if (minutes > 0) {
      return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
    } else {
      return `${seconds} ${seconds === 1 ? 'second' : 'seconds'} ago`;
    }
  };


  const handleInterest = (checking) => {
    if (!client_id) {
      navigate('/register-as-freelancer'); // Redirect if clientId is not found
      return; // Stop further execution
  }
    const payload = {
      recruiter_id: mutliJobId,
      freelancer_id: client_id,
      client_id: client_id,
      job: filterData
    }
    if (clientData.status == 0) {
      return toast.warning('Your Profile is not active.', {
        position: 'top-left',
      });
    } else {
      const userConfirmed = window.confirm("Are you sure you want to proceed?");
      if (userConfirmed) {

        axiosApi.post("/freelancer-booking-job", payload).then((response) => {
          
          navigate(`/Success-job/${filterData}`);
        })

          .catch((error) => {
            console.error("Error while booking recruiter:", error);
            // setErrorMsg(error?.response?.data?.error)
            if (error.response?.status == 400) {
              toast.warning(error?.response?.data?.error, {
                position: 'top-left',
              });
            } else {
              setShowNoCreditsModal(true);
              props?.onHide()
            }



          });

      } else {

      }
    }
  }



  return (
    <>
      <Modal
        {...props}

        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ display: "flex", justifyContent: "space-between", width: "100%" }} id="contained-modal-title-vcenter">
            <div style={{ fontSize: "17px", fontWeight: "400", color: "black" }}>Posted <span>{calculateTimeElapsed(hireTalentData?.created_at)}</span></div>
            <div> <button onClick={() => handleInterest(hireTalentData?.status)} className='btn btn-dark'> I'm Interested</button></div>

            {/* {props?.filterData?.results.project_budget} */}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body >
          <h5> <b>{hireTalentData?.job_title}</b> </h5>



          <div className='mt-1 mt-md-3'><span><b>Salary Package</b> </span> :<CurrencyRupeeIcon style={{ color: "green", fontWeight: "500" }} /><span style={{ color: "green", fontWeight: "500" }}>{hireTalentData?.job_salary ? hireTalentData?.job_salary : hireTalentData?.job_salary}</span> </div>
          <div className='mt-1 mt-md-3'><span><b>Experience Level</b> </span> : <span  >{hireTalentData?.experience_level}</span> </div>
          <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }} className='mt-1 mt-md-3'><span><b>Skill Required</b> </span> :
            <span style={{ color: "black", fontWeight: "500", display: "flex", flexWrap: "wrap", gap: "5px" }}>{hireTalentData?.job_skills?.map((skill, index) => (
              <button key={index} className='btn btn-light'>{skill?.name}</button>
            ))}
            </span>
            {/* {recuiterById?.skills ? (
                            <span style={{ color: "black", fontWeight: "500", display: "flex", flexWrap: "wrap", gap: "5px" }}>
                                {recuiterById.skills.map((skill, index) => (
                                    <button key={index} className='btn btn-light'>{skill?.name}</button>
                                ))}
                            </span>
                        ) : (
                            <span>No skills specified</span>
                        )} */}
          </div>
          <p className='mt-1 mt-md-3'>
          <pre style={{whiteSpace:"pre-wrap",fontFamily:`"Poppins", sans-serif`}}>
          {hireTalentData?.job_description}
          </pre>
            
          </p>
          <h5 className='mt-1 mt-md-3'>Industry Required</h5>

          {/* <div>Skills required:</div> */}
          <div className='mt-1'>
            <button style={{ background: "#F9E8C9", padding: "0.5rem", textTransform: "capitalize" }} className='btn btn-light'>{hireTalentData?.industry}</button>

          </div>
        </Modal.Body>

        {/* <Modal.Footer>
          <Button style={{ background: "black" }} onClick={props.onHide}>Close</Button>
        </Modal.Footer> */}
      </Modal>
      <Modal
        show={showNoCreditsModal}
        onHide={() => setShowNoCreditsModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title><WarningIcon style={{ color: "#FF8F00" }} /> Credit Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* {errorMsg} */}
          You don't have credit available in your account. <Link to='/credits'>Click here</Link> to buy credits.
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="primary" onClick={() => navigate('/credits')}>
                        Buy Points
                    </Button> */}
          <Button variant="dark" onClick={() => setShowNoCreditsModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer />

    </>
  )
}

export default HireJobModel